var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ecConfig)?_c('vue-echart',{attrs:{"white-mode":_vm.whiteMode,"config":_vm.ecConfig,"height":_vm.height}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }